/* jshint browser:true, esversion: 6 */
/* global jQuery, console, hyperSegments, ga */

const dynamicSegmentation = function(){
    
    /**
     * **** AB testing de los menus ****
     */
        
    if (location.pathname.indexOf("/es/") === 0) {

        var linkHazteSocio = document.querySelector("#menu-item-hazte-socio");
        var botonRojoHome = document.querySelector("#boton_rojo_home");
        var cajaLateralTitular = document.querySelector("#caja_lateral_home h5");
        var cajaLateralFrase = document.querySelector("#caja_lateral_home p");
        var cajaLateralLink = document.querySelector("#caja_lateral_home a");

        var abTestVariant;

        if (typeof localStorage == "object") {
            if ( localStorage.getItem("abTestVariant") === null ){
                abTestVariant = Math.floor(Math.random() * 3);
                localStorage.setItem("abTestVariant", abTestVariant.toString());
            } else {
                abTestVariant = Number(localStorage.getItem("abTestVariant"));
            }
        } else { // Not object
            abTestVariant = Math.floor(Math.random() * 3);
        }

        if ( localStorage.getItem("vUwHCIqOnmoQu4mc9gM") !== null ) { // Herencias
            
            if ( linkHazteSocio) {
                linkHazteSocio.textContent = "Testamento solidario";
                linkHazteSocio.setAttribute("href", "/es/que-puedes-hacer-tu/testamento-solidario/?gracias=gracias1");
                linkHazteSocio.setAttribute("data-click", "DIN2-menu");
            }

            if ( botonRojoHome ){
                botonRojoHome.textContent = "Testamento solidario";
                botonRojoHome.setAttribute("href", "/es/que-puedes-hacer-tu/testamento-solidario/?gracias=gracias2");
                botonRojoHome.setAttribute("data-click", "DIN2-boton-rojo");
            }

            if(cajaLateralTitular) {
                cajaLateralTitular.textContent = "Testamento solidario";
                cajaLateralFrase.textContent = "Tenemos que defender el planeta. Hay que hacerlo ahora y habrá que hacerlo mañana. No hay un planeta B.";
                cajaLateralLink.textContent = "Infórmate";
                cajaLateralLink.setAttribute("href", "/es/que-puedes-hacer-tu/testamento-solidario/?gracias=gracias3");
                cajaLateralLink.setAttribute("data-click", "DIN2-Caja-Lateral");
            }

        }
        
        var lastLabel = hyperSegments.getLastLabel(["TeGeCOHatmoQu4mc9gM","bhNJCLOKnmoQu4mc9gM","tXajCKTfkoEBELuJnPYD"]);
        
        if ( location.search.includes("newsletter-socios") || lastLabel === "bhNJCLOKnmoQu4mc9gM" ) { // Socios

            if ( linkHazteSocio) {
                linkHazteSocio.textContent = "Donación";
                linkHazteSocio.setAttribute("href", "/es/que-puedes-hacer-tu/donaciones/?gracias=gracias4");
                linkHazteSocio.setAttribute("data-click", "DIN-menu");
            }

            if ( botonRojoHome ){
                botonRojoHome.textContent = "Donación";
                botonRojoHome.setAttribute("href", "/es/que-puedes-hacer-tu/donaciones/?gracias=gracias4");
                botonRojoHome.setAttribute("data-click", "DIN-boton-rojo");
            }

            if(cajaLateralTitular) {
                cajaLateralTitular.textContent = "Haz una donación";
                cajaLateralFrase.textContent = "Tu contribución es importante para que podamos seguir defendiendo el planeta.";
                cajaLateralLink.textContent = "Dona";
                cajaLateralLink.setAttribute("href", "/es/que-puedes-hacer-tu/donaciones/?gracias=gracias5");
                cajaLateralLink.setAttribute("data-click", "DIN-Caja-Lateral");
            }

        } else if ( location.search.includes("newsletter-leads") || location.search.includes("newsletter-ex") || lastLabel === "TeGeCOHatmoQu4mc9gM" || lastLabel === "tXajCKTfkoEBELuJnPYD" ) { // Lead o ex-socio

           if ( linkHazteSocio) {
                linkHazteSocio.textContent = "HAZTE SOCIO/A";
                linkHazteSocio.setAttribute("href", "/es/que-puedes-hacer-tu/hazte-socio/");
                linkHazteSocio.setAttribute("data-click", "DIN-menu");
            }

            if ( botonRojoHome ){
                botonRojoHome.textContent = "HAZTE SOCIO/A";
                botonRojoHome.setAttribute("href", "/es/que-puedes-hacer-tu/hazte-socio/");
                botonRojoHome.setAttribute("data-click", "DIN-boton-rojo");
            }

            if(cajaLateralTitular) {
                cajaLateralTitular.textContent = "¡ÚNETE A GREENPEACE!";
                cajaLateralFrase.textContent = "Ayúdanos a seguir defendiendo el planeta de forma eficaz e independiente.";
                cajaLateralLink.textContent = "HAZTE SOCIO/A";
                cajaLateralLink.setAttribute("href", "/es/que-puedes-hacer-tu/hazte-socio/");
                cajaLateralLink.setAttribute("data-click", "DIN-Caja-Lateral");
            }
            
            
        }

    } // Fin /es/
};
/**
 * **** FIN AB testing de los menus ****
 */
